import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allReports: [],
  extension: {},
};

const getters = {
  GET_REPORTS(state) {
    return state.allReports;
  },
  GET_REPORT: (state) => (id) => {
    return state.allReports.find((cat) => cat.id === id);
  },
};

const mutations = {
  SET_ALL_REPORTS: (state, payload) => (state.allReports = payload),

  PUSH_REPORT: (state, payload) => state.allReports.push(payload),

  SET_EXTENSION: (state, payload) => (state.extension = payload),
};

const actions = {
  async REGISTER_REPORT({ state, commit }, payload) {
    try {
      const response = await PbxHttpClient.post(
        "/reportCalls/personaly",
        payload
      );
      //FOR TESTING
      // console.log(response);
      // commit("PUSH_REPORT", response.data.category);
      return;
    } catch (error) {
      return error.message.includes("422") ? 422 : error;
    }
  },

  async SHOW_REPORTS({ commit }, period) {
    try {
      const response = await PbxHttpClient.get(`/reportCalls/${period}`);
      // FOR TESTING
      //   console.log("SHOW", response);
      // commit("SET_ALL_REPORTS", response.data.data);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_EXTENSION({ commit }, id) {
    try {
      const response = await PbxHttpClient.get(`/showextension/${id}`);
      // FOR TESTING
      //   console.log("SHOW_EXTENSION", response);
      // commit("SET_EXTENSION", response.data.data);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
